import { z } from "zod";
import { constObjectValues } from "../utils/enum.utils.js";

const LOCALE_CODE_VALUES = {
  EN: "en",
  ES: "es",
  FR: "fr",
  DE: "de",
  PT: "pt",
  IT: "it",
  NL: "nl",
  PL: "pl",
  RU: "ru",
  ZH: "zh",
  JA: "ja",
  KO: "ko",
  NOT_SET: "not_set",
} as const;

export const LocaleCodeSchema = z.enum(LOCALE_CODE_VALUES);

export type LocaleCode = z.infer<typeof LocaleCodeSchema>;

export const SUPPORTED_LOCALES = constObjectValues(LOCALE_CODE_VALUES);

export const DEFAULT_LOCALE = LOCALE_CODE_VALUES.EN;

export const LocaleCode = {
  ...LOCALE_CODE_VALUES,
} as const;

/**
 * KnownLocale — a locale that names an actual language.
 *
 * Excludes the NOT_SET sentinel, which records "we could not determine the
 * locale" on stored text. Use this wherever a locale is an input to something
 * that has to pick a language, rather than a record of what was detected.
 */
export type KnownLocale = Exclude<LocaleCode, typeof LocaleCode.NOT_SET>;

const SUPPORTED_TRANSLATION_LOCALE_VALUES = {
  EN: LOCALE_CODE_VALUES.EN,
  ES: LOCALE_CODE_VALUES.ES,
} as const;

export const SupportedTranslationLocaleSchema = z.enum(
  SUPPORTED_TRANSLATION_LOCALE_VALUES,
);

/**
 * SupportedTranslationLocale — locales that must have translations.
 */
export type SupportedTranslationLocale = z.infer<
  typeof SupportedTranslationLocaleSchema
>;

export const SUPPORTED_TRANSLATION_LOCALES = constObjectValues(
  SUPPORTED_TRANSLATION_LOCALE_VALUES,
);
